<template>
  <div class="h-100">
    <div class="h-100">
        <div class="match-card-close">
            <button v-on:click="emitNext()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

      <div class="match-card match-card__match text-center">
        <div class="match-card__desc">
          <div class="title title--big title--white title--font-secondary">
            {{ trans.get('pages:match_game.api.profile_liked') }}
          </div>
          <div class="desc desc--white mt-1">
            {{ trans.get('pages:match_game.match_card.header') }}
          </div>
        </div>

        <div class="avatar-with-avatar">
          <div class="avatar-with-avatar__first heartbeat" :style="{'background-image':'url(' + user.web_avatar_url + ')'}"></div>
          <div class="avatar-with-avatar__second heartbeat" :style="{'background-image':'url(' + current.profile.avatar_url + ')'}"></div>
        </div>

        <div class="match-card__info">
          <div class="desc desc--white">
            {{ trans.get('pages:match_game.match_card.you_and') }} <strong>{{ current.profile.name }}</strong> {{ trans.get('pages:match_game.match_card.have_similar_minds') }}
          </div>
        </div>

        <div class="match-card__form">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 pr-2">
              <input v-model="message" type="text" class="input-text input-text__fill input-text__fill--white" minlength="3">
            </div>
            <button v-on:click="sendMessage()" class="button button__outline button__outline--white-hov-purple">{{ trans.get('pages:match_game.match_card.send_button') }}</button>
          </div>
        </div>

        <div class="mmatch-card__button">
          <button v-on:click="emitNext()" class="button button__link--underline button__link--white text-bold">{{ trans.get('pages:match_game.match_card.keep_looking_button') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'LikeCard',
  props: {
    value: Object,
    current: Object,
  },
  data() {
    return {
      message: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {
    emitNext() {
      this.$emit('input', { visible: false, });
      this.$emit('next', 'NEXT');
    },
    sendMessage() {
      return axios
        .post(zRoute('ajax.match_game.love_message', this.current.profile.id), {
          message: this.message,
        })
        .then(response => {
          if (response.data.status === 'success') {
            this.emitNext();
          }
        });
    },
  },
  mounted() {
  }
};
</script>


